
import { useUpdateCourtMutation } from '../store/Api';


export function useToggleCourtActivate() {
  const [update, { isLoading }] = useUpdateCourtMutation();

  const toggleCourtActivate = ({ courtId, state }: { courtId: number; state: boolean }) => {
    update({ id: courtId, active: !state });
  };

  return ({
    toggleCourtActivate,
    isLoading
  });
}
